import React from 'react';

import { useQuery } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';

import Table from '../../../../Table';
import Button from '../../../../Button';

import LienHolderService from '../../../../../services/LienHolderService';
import useUserRole from '../../../../../hooks/useUserRole';
import LenderService from '../../../../../services/LenderService';

export default function LienHolders({ lenderId }) {
  const navigate = useNavigate();

  const { isLender } = useUserRole();

  const cols = [
    {
      title: 'Name',
      keys: ['name'],
      link: (row) =>
        `/lenders/${lenderId}/lien-holders/${row.id}?tab=Lien Holder`,
    },
    {
      title: 'City',
      keys: ['city'],
    },
    { title: 'Email', keys: ['email'] },
    { title: 'Phone', keys: ['phone'] },
  ];

  const { data: lienHolders, isFetching } = useQuery({
    queryKey: ['lienHolders', lenderId, isLender],
    queryFn: () =>
      isLender
        ? LenderService.getLenderLienHolders(lenderId)
        : LienHolderService.getLienHolders(lenderId),
    enabled: !!lenderId,
  });

  /* const { mutate: createLienHolder, isPending } = useMutation({
    mutationFn: (formValues) =>
      LienHolderService.createLienHolder({ formValues, lenderId }),
    onSuccess: () => {
      showToast({
        text: 'Lien Holder created successfully',
        type: 'success',
      });
      refetch();
    },
    onError: (error) => {
      console.log(error);
      showToast({
        text: error?.response?.data?.message || 'Something went wrong',
        type: 'error',
      });
    },
  });
 */
  return (
    <div>
      <div className="mb-4 flex flex-col sm:flex-row justify-end gap-2">
        <Button
          className="md:!max-w-[200px]"
          onClick={() => {
            navigate(`/lenders/${lenderId}/lien-holders/new?tab=Lien Holder`);
          }}
        >
          <svg
            className="w-4 h-4 fill-current opacity-50 shrink-0"
            viewBox="0 0 16 16"
          >
            <path d="M15 7H9V1c0-.6-.4-1-1-1S7 .4 7 1v6H1c-.6 0-1 .4-1 1s.4 1 1 1h6v6c0 .6.4 1 1 1s1-.4 1-1V9h6c.6 0 1-.4 1-1s-.4-1-1-1z" />
          </svg>
          <span className="ml-2">Create Lien Holder</span>
        </Button>
      </div>
      <div className="p-7 col-span-full sm:col-span-6 xl:col-span-4 bg-white dark:bg-slate-800 shadow-lg rounded-sm border border-slate-200 dark:border-slate-700 mb-10">
        <h2 className="text-2xl text-slate-800 dark:text-slate-100 font-bold mb-6">
          Lien Holders
        </h2>
        <Table
          cols={cols}
          rows={lienHolders}
          title=""
          isFetching={isFetching}
          minHeight={565}
        />
      </div>
    </div>
  );
}
